var AlertType;
(function (AlertType) {
    AlertType["Info"] = "INFO";
})(AlertType || (AlertType = {}));
export default AlertType;
